// ReCaptchaHandler/index.mjs

import { reCAPTCHAv3 } from 'commonAssets/js/constants';

export class ReCaptchaHandler {
    static execute(tokenCallback) {
        grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then(token => {
            tokenCallback(token);
        });
    }
}